import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
export default {
  name: 'NiotaClassicDevicesAddAddNew',
  mixins: [formMixin],
  props: {
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    datasourceType: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      adrLimits: [{
        id: '0',
        title: 'SF 12 / BW 125 MHz'
      }, {
        id: '1',
        title: 'SF 11 / BW 125 MHz'
      }, {
        id: '2',
        title: 'SF 10 / BW 125 MHz'
      }, {
        id: '3',
        title: 'SF 9 / BW 125 MHz'
      }, {
        id: '4',
        title: 'SF 8 / BW 125 MHz'
      }, {
        id: '5',
        title: 'SF 7 / BW 125 MHz'
      }, {
        id: '6',
        title: 'SF 7 / BW 250 MHz'
      }],
      connectivityPlans: [],
      deviceProfiles: [],
      qrScanner: false,
      deviceData: {},
      otaa: true,
      addressObject: {
        address: '',
        coordinates: [null, null]
      },
      operationalStatus: [{
        value: 0,
        text: this.$i18n_t('NiotaClassic.Devices.form.unset')
      }, {
        value: 1,
        text: this.$i18n_t('NiotaClassic.Devices.form.inTransit')
      }, {
        value: 2,
        text: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation')
      }, {
        value: 3,
        text: this.$i18n_t('NiotaClassic.Devices.form.inOperation')
      }, {
        value: 4,
        text: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive')
      }, {
        value: 5,
        text: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      }],
      motionIndicators: ['NEAR_STATIC', 'WALKING_SPEED', 'BIKE_SPEED', 'VEHICLE_SPEED', 'RANDOM'],
      actilityOptionsIsLoading: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isUdp: function isUdp() {
      if (this.datasourceType === 'udp') {
        return true;
      } else {
        return false;
      }
    },
    isFirefly: function isFirefly() {
      if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
        return true;
      } else {
        return false;
      }
    },
    isActility: function isActility() {
      if (this.datasourceType === 'actility') {
        return true;
      } else {
        return false;
      }
    },
    isWebhookOrFilesys: function isWebhookOrFilesys() {
      if (this.datasourceType === 'webhook' || this.datasourceType === 'filesystem') {
        return true;
      } else {
        return false;
      }
    },
    buttons: function buttons() {
      return [{
        icon: 'fal fa-arrow-left',
        action: 'back',
        tooltip: this.$i18n_t('Common.reset')
      }, {
        icon: 'fal fa-barcode-read',
        action: 'qr',
        tooltip: this.$i18n_t('NiotaClassic.Devices.form.qrScanner')
      }, {
        icon: 'fas fa-save',
        tooltip: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    coordinateLookup: function coordinateLookup() {
      return get(this.deviceData, 'properties.coordinateMode') !== 'manual';
    }
  }),
  watch: {
    datasourceType: function datasourceType() {
      this.initData();
    },
    editedItem: function editedItem() {
      this.initData();
    }
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.deviceData = cloneDeep(this.editedItem);

      if (!this.deviceData.properties) {
        this.deviceData.properties = {};
        this.deviceData.region = 'EU868';
      }

      if (this.datasourceType === 'actility') {
        this.fetchActilityOptions();
      }

      this.setAddressObject();
    },
    filterItems: function filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    filterConnectivityPlan: function filterConnectivityPlan(item, queryText) {
      return item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    fetchActilityOptions: function fetchActilityOptions() {
      var _this = this;

      this.actilityOptionsIsLoading = true;
      NiotaClassicApiService.fetchActilityOptions(this.editedItem.originatorId).then(function (res) {
        var connectivityPlans = get(res, 'data.connectivity_plans');
        var deviceProfiles = get(res, 'data.device_profiles');

        if (isArray(connectivityPlans)) {
          _this.connectivityPlans = res.data.connectivity_plans;
        } else {
          _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.actilityError'), 'error');

          console.error(connectivityPlans);
        }

        if (isArray(deviceProfiles)) {
          _this.deviceProfiles = res.data.device_profiles;
        } else {
          _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.actilityError'), 'error');

          console.error(deviceProfiles);
        }
      }).catch(function (error) {
        _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingActilityOptions'), 'error');

        console.error(error);
      }).finally(function () {
        _this.actilityOptionsIsLoading = false;
      });
    },
    createDevice: function createDevice() {
      var _this2 = this;

      NiotaClassicApiService.deviceCreate(this.deviceData).then(function (res) {
        if (!res.data.err) {
          _this2.deviceData = res.data.device;

          _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.createSuccess'), 'success');

          _this2.$emit('refreshList');

          _this2.$emit('close');
        } else {
          _this2.$snack(res.data.err, 'error');
        }
      }).catch(function (error) {
        if (error.response && error.response.data && error.response.data.err) {
          _this2.$snack(error.response.data.err, 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.createFailed'), 'error');
        }
      });
    },
    randomEui: function randomEui() {
      this.deviceData.eui = this.randomString(16);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomDeviceAddress: function randomDeviceAddress() {
      this.deviceData.deviceAddress = this.randomString(8);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomApplSessionKey: function randomApplSessionKey() {
      this.deviceData.applSessionKey = this.randomString(32);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomApplKey: function randomApplKey() {
      this.deviceData.applKey = this.randomString(32);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomNetwSessionKey: function randomNetwSessionKey() {
      this.deviceData.netwSessionKey = this.randomString(32);
      this.deviceData = cloneDeep(this.deviceData);
    },
    randomString: function randomString(len) {
      var charSet = 'ABCDEF0123456789';
      var randomString = '';

      for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
      }

      return randomString;
    },
    addNewDevice: function addNewDevice() {
      this.deviceData = this.newDevice();
      this.createDevice();
    },
    newDevice: function newDevice() {
      this.deviceData.cType = this.datasourceType;

      if (this.deviceData.deviceType && this.deviceData.deviceType.id) {
        this.deviceData.deviceTypeId = this.deviceData.deviceType.id;
        this.deviceData.deviceTypeTitle = this.deviceData.deviceType.title;
      }

      if (this.datasourceType === 'firefly_mqtt' || this.datasourceType === 'firefly') {
        this.deviceData.cType = 'firefly';

        if (this.deviceData.adr_limit && this.deviceData.adr_limit.id) {
          this.deviceData.adr_limit_name = this.deviceData.adr_limit.title;
          this.deviceData.adr_limit = this.deviceData.adr_limit.id;
        }

        if (this.deviceData.region && this.deviceData.region.id) {
          this.deviceData.region_name = this.deviceData.region.title;
          this.deviceData.region = this.deviceData.region.id;
        }
      } else if (this.datasourceType === 'actility') {
        if (this.deviceData.connectivity_plans && this.deviceData.connectivity_plans.id) {
          this.deviceData.connectivityPlanId = this.deviceData.connectivity_plans.id;
          this.deviceData.connectivityPlanName = this.deviceData.connectivity_plans.name;
          this.deviceData.connectivity_planName = this.deviceData.connectivity_plans.name;
        }

        if (this.deviceData.device_profiles && this.deviceData.device_profiles.id) {
          this.deviceData.deviceProfileId = this.deviceData.device_profiles.id;
          this.deviceData.device_profileName = this.deviceData.device_profiles.name;
        }
      }

      if (this.otaa) {
        this.deviceData.otaa = true;
      } else {
        this.deviceData.otaa = false;
      }

      return this.deviceData;
    },
    setAddressObject: function setAddressObject() {
      this.addressObject = {
        address: this.deviceData.physicalAddress,
        coordinates: [this.deviceData.lon || null, this.deviceData.lat || null]
      };
    },
    addressSelected: function addressSelected(addressData) {
      this.deviceData.physicalAddress = addressData.address;

      var _addressData$coordina = _slicedToArray(addressData.coordinates, 2);

      this.deviceData.lon = _addressData$coordina[0];
      this.deviceData.lat = _addressData$coordina[1];
      this.deviceData.properties = _objectSpread(_objectSpread({}, this.deviceData.properties || {}), {}, {
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      });
      this.setAddressObject();
    },
    tagsChanged: function tagsChanged(tags) {
      this.deviceData.tags = tags;
    }
  }
};